export const REGION = 'us-east-1';

// WITHOUT DUO LOGIN CONFIG

export const DIRECT_CLIENT_ID = '6vr1jqmahnqps6oabkqh61k8n8';

// DUO LOGIN CONFIG START

export const USER_POOL_CLIENT_ID = '5mtlbd5i102sn28oumlvrf5isv';

export const COGNITO_DOMAIN = 'us-east-1cuuog0n1a.auth.us-east-1.amazoncognito.com';

// export const FRONT_END_DOMAIN = "d3iqyab8hc1p2w.cloudfront.net";

export const FRONT_END_DOMAIN = "app.legalstream.org";
export const BACK_END_API_URL = "https://app.legalstream.org";
// export const BACK_END_API_URL = "http://localhost:8081";

export const VERIFICATION_METHOD = 'code';

export const SCPOPES = ["email", "profile", "openid"];

// DUO LOGIN CONFIG END

export const DOCUMENT_TYPES = ['ANSWER', 'BK', 'COMM', 'COMPLAINT', 'COUNTERCLAIM', 'DEMAND', 'DISMISSAL', 'DISPUTE', 'DOME', 'GARN', 'JUDGMENT', 'LIEN', 'MISC', 'PSOJ', 'ROG', 'ROS', 'SOJ', 'VOD'];


export const REPORT_IDs = {
  ccmr: "3d2a4cdd-918b-4c44-96ea-35965578f134",
  dq: "25bf41b6-1e12-4bc7-b718-cb625e9e7fa9",
  "ccmr-sla": "5ced832a-613b-4162-8d45-6cce8b9bb4b0"
};